import baseApi from 'api/baseApi';
import { IRequestOptions } from 'common/interfaces/dictionary';
import { IPaginatedData } from 'common/interfaces/pagination';
import { IReqMarkReadParams, IUserNotification } from 'interfaces/userNotification.interfaces';
import { TagType } from 'common/enums/api.enums';

const userNotificationApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    getMPUserNotifications: builder.query<
      IPaginatedData<IUserNotification>,
      IRequestOptions | void
    >({
      query: (params = {}) => ({
        url: '/api/v1/member-portal/notifications',
        method: 'GET',
        params: {
          ...params,
          active: true,
          validityPeriod: 30,
        },
      }),
      providesTags: [TagType.MemberPortalUserNotifications],
    }),
    getMPUserNotificationsCount: builder.query<number, void>({
      query: () => ({
        url: '/api/v1/member-portal/notifications/count',
        method: 'GET',
        params: {
          active: true,
          validityPeriod: 30,
        },
      }),
      providesTags: [TagType.MemberPortalUserNotificationsCount],
    }),
    readMPUserNotification: builder.mutation<void, IReqMarkReadParams>({
      query: params => ({
        url: `/api/v1/member-portal/notifications/${params.uuid}/read`,
        method: 'PUT',
        data: {
          read: params.read,
        },
      }),
      invalidatesTags: (result, error) => {
        if (!error) {
          return [
            TagType.MemberPortalUserNotifications,
            TagType.MemberPortalUserNotificationsCount,
          ];
        }

        return [];
      },
    }),
    readMPUserNotifications: builder.mutation<void, void>({
      query: () => ({
        url: '/api/v1/member-portal/notifications/read',
        method: 'PUT',
        data: {
          read: true,
        },
      }),
      invalidatesTags: (result, error) => {
        if (!error) {
          return [
            TagType.MemberPortalUserNotifications,
            TagType.MemberPortalUserNotificationsCount,
          ];
        }

        return [];
      },
    }),
  }),
});

export const {
  useGetMPUserNotificationsQuery: useGetUserNotifications,
  useGetMPUserNotificationsCountQuery: useGetUserNotificationsCount,
  useReadMPUserNotificationMutation: useReadUserNotification,
  useReadMPUserNotificationsMutation: useReadUserNotifications,
} = userNotificationApi;

export default userNotificationApi;
